import { useEffect, useState } from 'react';
import api from '../../Components/RefreshToken/RefreshToken';

// Tab sarlavhalari uchun umumiy sonlar (filtrsiz total_count) va dashboard'dagi total_students.
// Sahifa ochilganda bir marta olinadi. Xato bo'lsa — null (son ko'rsatilmaydi).
const authHeaders = () => ({
  accept: 'application/json',
  Authorization: `Bearer ${localStorage.getItem('admin_token')}`,
});

const totalCount = (url) =>
  api
    .get(url, { params: { skip: 0, limit: 1 }, headers: authHeaders() })
    .then((res) => (typeof res?.data?.total_count === 'number' ? res.data.total_count : null))
    .catch(() => null);

const registeredCount = () =>
  api
    .get('/management/dashboard/statistics/head', { headers: authHeaders() })
    .then((res) => (typeof res?.data?.total_students === 'number' ? res.data.total_students : null))
    .catch(() => null);

export function useStudentTotals() {
  const [totals, setTotals] = useState({ enrolled: null, notEnrolled: null, registered: null });

  useEffect(() => {
    let active = true;
    Promise.all([totalCount('/management/students'), totalCount('/management/students/not-enrolled'), registeredCount()]).then(
      ([enrolled, notEnrolled, registered]) => {
        if (active) setTotals({ enrolled, notEnrolled, registered });
      }
    );
    return () => {
      active = false;
    };
  }, []);

  // Dashboard'dagi jami son ikki ro'yxat yig'indisiga teng bo'lsagina ko'rsatiladi
  const consistent =
    totals.enrolled !== null && totals.notEnrolled !== null && totals.registered !== null && totals.registered === totals.enrolled + totals.notEnrolled;

  return { ...totals, consistent };
}
